
import $ from "cash-dom";
import { request, apiBase } from "@common/request";
import { assetUrl } from "@common/utils/asset-url";


const MainLeaderBoard = (DateFilters) => {
    var startDate = '';
    var endDate = '';
    var MainUsers = [];
    //var users;
    $(() => {
        filterTabs(0)
        getDates('weekFilter')
        leaderboardData()
    })
    let users = [];
    const leaderboardData = () => {
        // NO LEADERBOARD ENDPOINT EXISTS YET (checked 18 Aug 2026):
        // /submissions/leaderboard, /leaderboard, /submissions/top-users and
        // /users/leaderboard all 404, and International's own submit page has
        // no leaderboard at all — the word appears there only in marketing
        // copy. Written against the route it will use, so wiring it later is
        // nothing but a deploy; until then request.get resolves null, the
        // guard below holds, and the table stays empty.
        request.get(apiBase() + '/submissions/leaderboard')
            .then((result) => {
                // The shape is a guess until the endpoint is real, so both a
                // bare array and an {items|data} envelope are accepted.
                const rows = Array.isArray(result)
                    ? result
                    : (result && (result.items || result.data)) || null;
                if (rows != null) {
                    MainUsers = rows;
                    users = [...MainUsers].slice(0, 5);
                    leaderBoardSorting();
                }
            });
    }
    const tBody = $("#leaderBoardBody");
    const leaderBoardSorting = () => {
        let newUsers = users.sort((a,b) => b.Points - a.Points)
        
        let getUsers = LeaderBoard(newUsers)
        tBody.html(getUsers)
    }



    const getDates = (filter) => {
        if (filter === 'weekFilter') {
            var curr = new Date; // get current date
            var firstDay = new Date(curr.setDate(curr.getDate() - curr.getDay()));
            var lastDay = new Date(curr.setDate(curr.getDate() - curr.getDay() + 6));
            startDate = formatDate(firstDay);
            endDate = formatDate(lastDay);
            return;
        }
        else {
            var date = new Date();
            var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
            var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            startDate = formatDate(firstDay);
            endDate = formatDate(lastDay);
        }
    }


    const formatDate = (date) => {
        
        let d = new Date(date);
        let month = (d.getMonth() + 1).toString();
        let day = d.getDate().toString();
        let year = d.getFullYear();
        if (month.length < 2) {
            month = '0' + month;
        }
        if (day.length < 2) {
            day = '0' + day;
        }
        return [year, month, day].join('-');
    }




    const LeaderBoard = (users) => {
        let html = '';
        if(users === 0){
            leaderBoardSorting();
            return;
        }
        if(users.length == 0){
            html =  `<tr class='text-center'>
                        <td colspan="6" >
                            <img src='${assetUrl("noResutsFound.gif")}' alt='No Results Found' />
                            <span>No Results Found</span>
                        </td>
                    </tr>`
            return html;
        }
        else{
            // html = users.map((user) => {
            //     return `<tr>
            //     <td>${user.Rank}</td>
            //     <td>
            //         <span>
            //             <span class='userImgSpan'>
            //                 <img src='${user.Image}' alt='${user.Name} profile' />
            //             </span>
            //             <span class='userNameSpan'>
            //                 ${user.FirstName}
            //             </span>
            //         </span>
            //     </td>
            //     <td>${user.EmailAddress}</td>
            //     <td>${user.CouponCount}</td>
            //     <td>${user.MerchantCount}</td>
            //     <td>
            //         <span>
            //             ${user.Points}
            //         </span>
            //         ${user.Rank == 1 ? '<span class="RankImgSpan"><img src="https://cdn.grabon.in/gograbon/v7/img/gold.png" /></span>':''}
            //         ${user.Rank == 2 ? '<span class="RankImgSpan"><img src="https://cdn.grabon.in/gograbon/v7/img/silver.png" /></span>':''}
            //         ${user.Rank == 3 ? '<span class="RankImgSpan"><img src="https://cdn.grabon.in/gograbon/v7/img/bronze.png" /></span>':''}
            //     </td>
            //     </tr>`
            // }).join('');
            html = users.map((user) => {
                return `<tr>
                <td>
                    <span class="leaderboardFlex">
                        <div class="userNameFlex">
                            <p class="userRank">${user.Rank}</p>
                            <span>
                                <p>${user.FirstName}</p>
                                <p>Points: ${user.Points}</p>
                            </span>
                        </div>
                        <img src="${assetUrl("crowdsourcing-medal.png")}">
                    </span>
                </td>
            </tr>
                `
            }).join('');
            return html;
        }
    }


    $('body').on('keyup','#searchUsers',(e) => {
        const searchText = e.target.value;
        var newUsers = users.filter((user,index) => {
            return user.Name.toLowerCase().includes(searchText.toLowerCase())
        })

        if(searchText == ''){
            LeaderBoard(0)
        }

        if(searchText != ''){
            let ul = LeaderBoard(newUsers)
            tBody.html(ul)
        }
    });

    let showMoreUsers = false;


    $('body').on('click','.showMoreSpan',(e) => {
        showMoreUsers = !showMoreUsers;
        if(showMoreUsers){
            users = [...MainUsers];
            $('.showMoreSpan').html('Show Less');
        }
        else{
            users = [...MainUsers].slice(0,5);
            $('.showMoreSpan').html('Show More');
        }

        leaderBoardSorting();
    })

    leaderBoardSorting()

    const showMore = `<span class="showMoreSpan">
                        Show More
                    </span>`

    if(users.length > 4){
        $('.leaderBoard').append(showMore)
    }                

    let filters = [...DateFilters];
    const filterUl = $('#filteredTabs');

    const filterTabs = (ClickIndex) => {
        const html = filters.map((filterTab,index) => {
            return `<li class='${ClickIndex == index ? 'active':''} filterLi' data-id='${index}' data-target='${index == 0 ? 'weekFilter':'monthFilter'}'>${filterTab.name}</li>`
        }).join('')

        filterUl.html(html);
    }



    $('body').on('click','.filterLi',(e) => {
        let index = e.target.getAttribute('data-id');
        let target = e.target.getAttribute('data-target');
        filterTabs(index);
        getDates(target);
        switch(target){
            case 'weekFilter':

                leaderboardData();
                break;

            case 'monthFilter':

                leaderboardData();
                break;    
        }
    })
}

export default MainLeaderBoard